import { request } from "../API/request";

export const getLast10Digits = (str) => {
    if (!str?.length) return;
    const digits = str.match(/\d/g);
    return digits && digits.length >= 10
        ? digits.slice(-10).join('')
        : null;
}

const parsePhone = (data) => {
    const phoneString = data.find((item) => item?.type?.name === 'Телефон')?.data;
    if (phoneString && phoneString.length > 2) {
        return getLast10Digits(phoneString);
    } else {
        return null;
    }
};

export const getUserPhone = async (stf) => {
    try {
        let response;

        if (stf) {
            // Если сотрудник
            response = await request({
                method: 'GET',
                url: '/v1/user/contacts?source=NSI3'
            }, true, 'contactsNSI3');
        } else {
            // Если студент
            response = await request({
                method: 'GET',
                url: '/v1/user/contacts?source=CONTINGENT'
            }, true, 'contactsContingent');
        }

        // Парсим и возвращаем телефон
        return parsePhone(response.data);

    } catch (error) {
        return null; // или выбросить ошибку, в зависимости от требований
    }
};
